module.exports = "/assets/review-boy.png?guvWKxN";